export const NAVIGATOR_STEPS = ['registerIntroduction', 'email', 'phoneNumber', 'password', 'completion'];
